import * as React from 'react';
import {
  useGridApiContext,
  GridPagination,
  GridRenderPaginationProps,
} from '@mui/x-data-grid';
import {
  GridFooterContainer,
  GridPagination as GridPaginationPro,
} from '@mui/x-data-grid-pro';
import {TablePaginationProps} from '@mui/material/TablePagination';
import MuiPagination from '@mui/material/Pagination';
import {Box, Button, Typography} from '@mui/material';
import IconRequestSong from '../../../asset/icons/icon_addsong.svg';
import {messageConfig} from '../../../constants/messages';

function Pagination({
  page,
  onPageChange,
  className,
}: Readonly<
  Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'>
>) {
  const apiRef = useGridApiContext();
  const rowsCount = apiRef.current.getRowsCount();
  const pageCount = apiRef.current.state.pagination.paginationModel.pageSize;

  return (
    <MuiPagination
      color='primary'
      className={className}
      count={Math.ceil(rowsCount / pageCount)}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(
          event as React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
          newPage - 1,
        );
      }}
    />
  );
}

export function DataGridCustPagination(
  props: Readonly<GridRenderPaginationProps>,
) {
  return <GridPagination ActionsComponent={Pagination} {...props} />;
}

type CustomFooterProps = {
  enableSongRequest: boolean | undefined;
  onRequestSongClick: () => void;
};

export const RequestSongGridFooter = ({
  enableSongRequest,
  onRequestSongClick,
}: CustomFooterProps) => {
  if (!enableSongRequest) {
    return null;
  }
  return (
    <GridFooterContainer>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          pl: 2,
          background: 'linear-gradient(45deg, #0f121a, transparent)',
        }}>
        <Box>
          <Typography variant='h5' className='font-bold'>
            {messageConfig.requestSong.message1}
          </Typography>
          <Typography variant='h5' className='font-bold'>
            {messageConfig.requestSong.message2}
          </Typography>
        </Box>
        <Button
          variant='contained'
          color='secondary'
          className='my-7 mx-11 min-w-200'
          onClick={onRequestSongClick}>
          <img src={IconRequestSong} alt='Create New' className='mr-4' />
          Request Song
        </Button>
      </Box>
      <GridPaginationPro />
    </GridFooterContainer>
  );
};
